
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cardprocessingoffers/privacy-policy",
      function () {
        return require("private-next-pages/cardprocessingoffers/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cardprocessingoffers/privacy-policy"])
      });
    }
  